import type { SVGProps } from "react";
import * as React from "react";

const SvgGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 25 25"
    {...props}
  >
    <g clipPath="url(#google_svg__a)">
      <path
        fill="#4285F4"
        d="M24.016 12.776c0-.815-.066-1.635-.207-2.438H12.49v4.621h6.482a5.56 5.56 0 0 1-2.399 3.647v2.998h3.867c2.271-2.09 3.576-5.177 3.576-8.828"
      />
      <path
        fill="#34A853"
        d="M12.49 24.5c3.237 0 5.966-1.062 7.955-2.896l-3.867-2.998c-1.076.731-2.465 1.146-4.083 1.146-3.131 0-5.786-2.112-6.738-4.952h-3.99v3.091a12 12 0 0 0 10.723 6.61"
      />
      <path
        fill="#FBBC04"
        d="M5.753 14.8a7.2 7.2 0 0 1 0-4.594V7.115H1.767a12.01 12.01 0 0 0 0 10.776z"
      />
      <path
        fill="#EA4335"
        d="M12.49 5.25a6.52 6.52 0 0 1 4.603 1.799l3.427-3.426A11.53 11.53 0 0 0 12.49.5 12 12 0 0 0 1.767 7.115l3.986 3.09C6.7 7.363 9.359 5.25 12.49 5.25"
      />
    </g>
    <defs>
      <clipPath id="google_svg__a">
        <path
          fill="#fff"
          d="M.25.5h24v24h-24z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgGoogle;
